import React, { useEffect, useState, } from 'react';
import { Link, } from 'react-router-dom';
import HtmlParser from 'react-html-parser';

import 'react-tempusdominus-bootstrap';
import moment from 'moment-timezone';

import axios from 'axios';
import $ from 'jquery';

import Swal from 'sweetalert2';

import useAuth from '../../controllers/users/useAuth';
import { expenseTemplateDetailModelGet, expenseTemplateModelGet } from '../../models/expenses/template';
import {
    checkIfUserIsMaster, dataTableLanguaje, responseGet, globalSettings, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, buttonProcessGet, numberSet,
    awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection,
} from '../../helpers/settings';

import Menu from '../main/Menu';
import ConceptFind from './ConceptFind';
import ConceptEdit from './ConceptEdit';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { validationExpenseConceptGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';

const currentMethod = 'Templates';

export default function Templates({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    let swalProperties = {};
    //const history = useHistory();
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: languageObj?.id, subMethod: currentMethod, })?.result;
    const [receiptGeneratedMessage, setReceitGeneratedMessage] = useState('');
    const [processType, setProcessType] = useState(-1);
    const [showLoading, setShowLoading] = useState({ buildings: true, expenseTemplates: true, expenseTemplate: true, });
    //#endregion variables

    //#region concepts
    const dtConceptsId = 'dtConcepts';
    const [conceptFinds, setConceptFinds] = useState([]);
    const [conceptData, setConceptData] = useState({ id: '', description: '', rowIndex: 0, processType: 0, expenseConceptId: '', });
    const [conceptAddShowModal, setConceptAddShowModal] = useState(false);
    const [conceptEditShowModal, setConceptEditShowModal] = useState(false);
    //#endregion concepts

    //#region templates
    const dtTemplatesId = 'dtTemplates';
    const [dtExpenseTemplatesRowIndex, setDtExpenseTemplatesRowIndex] = useState(0);
    //#endregion templates

    //#region template
    const templateDateId = 'templateDate';
    const [dateError, setDateError] = useState('');
    const [detailsError, setDetailsError] = useState('');
    const [isEditDelete, setIsEditDelete] = useState(false);
    const [descriptionError, setDescriptionError] = useState('');
    const [templateIsEditabled, setTemplateIsEditabled] = useState(true);
    const [template, setTemplate] = useState(expenseTemplateModelGet({}));
    const [btnTemplateSyncDisabled, setBtnTemplateSyncDisabled] = useState(true);
    //#endregion template

    //#region buildings
    const buildingsId = 'buildings';
    const [building, setBuilding] = useState({});
    const [buildings, setBuildings] = useState([]);
    //#endregion buildings

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnSave',
                className: 'btn btn-outline-primary mx-1',
            },
            new: {
                id: 'btnNew',
                className: 'btn btn-outline-success',
            },
            duplicate: {
                id: 'btnDuplicate',
                className: 'btn btn-outline-warning mx-1',
            },
            addDetail: {
                id: 'btnAddDetail',
                className: 'btn btn-outline-info',
            },
            delete: {
                id: 'btnDelete',
                className: 'btn btn-outline-danger mx-1',
            },
            conceptEdit: {
                id: 'btnConceptEdit',
                className: 'btn btn-outline-warning',
            },
            conceptDelete: {
                id: 'btnConceptDelete',
                className: 'btn btn-outline-danger mx-1',
            },
        },
        inputs: {
            description: {
                id: 'inputDescription',
                className: 'form-control bg-transparent text-black',
            },
            date: {
                id: 'inputDate',
                className: 'form-control bg-transparent text-black datetimepicker-input',
            },
            expenseTemplateTotal: {
                id: 'inputExpenseTemplateTotal',
                className: 'form-control bg-transparent text-black text-right',
            },
        },
        dataTables: {
            expenseTemplate: {
                buttons: {
                    // create: {
                    //     className: 'btn btn-outline-success float-right btn-sm',
                    //     id: 'btnDtExpenseConceptsCreate',
                    // },
                },
                icons: {
                    // create: {
                    //     id: 'iconDtExpenseConceptsCreate',
                    //     className: globalSettings?.icons?.plusCircle,
                    // },
                },
                inputs: {
                    search: {
                        id: `${dtConceptsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtConceptsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    // create: {
                    //     id: 'spDtExpenseConceptsCreate',
                    //     className: '',
                    // },
                },
            },
        },
        icons: {
            save: {
                id: 'icoSave',
                className: globalSettings?.icons?.save,
            },
            new: {
                id: 'icoNew',
                className: globalSettings?.icons?.fileFar,
            },
            duplicate: {
                id: 'icoDuplicate',
                className: globalSettings?.icons?.copyFarFa,
            },
            addDetail: {
                id: 'icoAddDetail',
                className: globalSettings?.icons?.listOl,
            },
            delete: {
                id: 'icoDelete',
                className: globalSettings?.icons?.trash,
            },
        },
        spinners: {
            save: {
                id: 'spSave',
                className: '',
            },
            new: {
                id: 'spNew',
                className: '',
            },
            duplicate: {
                id: 'spDuplicate',
                className: '',
            },
            addDetail: {
                id: 'spAddDetail',
                className: '',
            },
            delete: {
                id: 'spDelete',
                className: '',
            },
        },
    };
    //#endregion others

    //#region template (methods)
    const dataTableTemplatesSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableTemplatesSetAsync';
        let response = responseGet();
        try {
            $(`#${dtTemplatesId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    // { title: 'id', orderable:false, searchable: false, visible: false, width: '0%', },
                    { title: globalSettings?.labels?.date?.[languageObj?.id], searchable: false, orderable: false, visible: false, width: '0%', },
                    { title: globalSettings?.labels?.description?.[languageObj?.id], width: '80%', },
                    { title: globalSettings?.labels?.date?.[languageObj?.id], orderable: false, width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                //order: [[0, 'asc'],],
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtTemplatesId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const expenseTemplatesGetAsync = async ({ e = {}, processType_ = 's', subMethod = '', }) => {
        const currentMethod = 'expenseTemplatesGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let expenseTemplatesLocal = [];
            let buildingLocal = buildingModelGet({});
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            setShowLoading({ buildings: false, expenseTemplates: true, expenseTemplate: true, });

            //#region Initialization
            setTemplate(
                expenseTemplateModelGet({
                    buildingId: buildingIdLocal,
                    userId: auth?.user?.uid,
                })
            );

            response = await dateInControlSetAsync({
                date: new Date(),
                expenseTemplateDate: undefined,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                return
            }

            response = await errosDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                return;
            }

            response = await dataTablesClearAsync({
                dtTemplates: true,
                dtConcepts: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                return;
            }

            setProcessType(-1);
            setDtExpenseTemplatesRowIndex(0);
            setReceitGeneratedMessage('');
            setBtnTemplateSyncDisabled(true);
            //#endregion Initialization

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id, }) => id === buildingIdLocal);
                setBuilding(buildingLocal);
                if (!isUndNullEmp({ data: buildingLocal?.id, subMethod: currentMethod, })?.result) {
                    //#region data get
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        }
                    };

                    dataObj = {
                        buildingId: buildingIdLocal,
                        conditionals: [
                            { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${buildingIdLocal}` },
                        ],
                        ordersBy: [
                            { field: globalSettings?.collections?.properties?.description, value: 'asc', }
                        ],
                        limit: 0,
                        languageId: languageObj?.id,
                        url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data;

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    expenseTemplatesLocal = response.result;
                    //#endregion data get

                    //#region dtRows add
                    if (!isUndNullEmp({ data: expenseTemplatesLocal, subMethod: currentMethod, })?.result && expenseTemplatesLocal?.length > 0) {
                        expenseTemplatesLocal?.map((detail) => (
                            dtRows.push([
                                dateTimeFormatGlobalSet({
                                    date: detail?.date,
                                    type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                                    //format: 24,
                                    format: 0,
                                    addTime: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                detail?.description,
                                //dateTimeFormatGlobalSet(detail.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy).result,
                                dateTimeFormatGlobalSet({
                                    date: detail?.date,
                                    type: languageObj?.format?.date?.f1,
                                    format: 0,
                                    addTime: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                })?.result,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: detail?.description,
                                    showDetails: true,
                                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: false,
                                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                                    enabledEdit: false,
                                    showDelete: false,
                                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                                    enabledDelete: false,
                                    processButtons: [],
                                    subMethod: currentMethod,
                                })?.result
                            ])
                        ));
                    }
                    //#endregion dtRows add

                    //#region data set
                    setProcessType(0);
                    setTemplate(
                        expenseTemplateModelGet({
                            buildingId: buildingIdLocal,
                            userId: auth?.user?.uid,
                        })
                    );
                    setBtnTemplateSyncDisabled(false);
                    //#endregion data set

                    //#region check is edit / delete
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: globalSettings?.labels?.process?.en?.toLowerCase(),
                        process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;
                    isDeleteLocal = isEditLocal;

                    setIsEditDelete((isEditLocal && isDeleteLocal));
                    //#endregion check is edit / delete

                    //#region set datatables / set query code / set data in datatables
                    $(`#${dtTemplatesId}`)?.DataTable()?.rows?.add(dtRows)?.draw();
                    //#endregion set datatables / set query code / set data in datatables
                }
            }

            //#region dateTime in control set
            response = await dateInControlSetAsync({
                date: new Date(),
                expenseTemplateDate: undefined,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dateTime in control set

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataSetAsync = async ({ property = '', value = '', subMethod = '', }) => {
        const currentMethod = 'formDataSetAsync';
        let response = responseGet();
        try {
            setTemplate({ ...template, [property]: value, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const expenseTemplateAddGetAsync = async ({ e = {}, subMethod = '' }) => {
        const currentMethod = 'expenseTemplateAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            controlsStatusSet({ processType: 2, subMethod: currentMethod, });

            //#region initialize
            setTemplateIsEditabled(true);
            setReceitGeneratedMessage('');

            response = await dateInControlSetAsync({
                date: new Date(),
                expenseTemplateDate: undefined,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setTemplateIsEditabled(false);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });

            if (!response?.isSuccess || response?.isWarning) {
                setTemplateIsEditabled(false);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                return;
            }
            //#endregion initialize

            //#region methods
            const objBuilding = $(`#${buildingsId}`);
            const buildingIdLocal = objBuilding?.val();
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                await dataTablesClearAsync({
                    dtTemplates: false,
                    dtConcepts: true,
                    subMethod: currentMethod,
                });
                setTemplate(
                    expenseTemplateModelGet({
                        buildingId: buildingIdLocal,
                        userId: auth?.user?.uid,
                    })
                );
                setProcessType(0);
                $(`#${controls?.inputs?.description?.id}`)?.trigger('focus');
            } else {
                setTemplateIsEditabled(false);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                response.msgType = 1;
                response.isWarning = true;
                response.msgText = globalSettings?.messages?.youMustSelectBuilding?.[languageObj?.id];
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                objBuilding.trigger('focus');
                return;
            }
            //#endregion methods

            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            setTemplateIsEditabled(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const expenseTemplateAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'expenseTemplateAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region data save
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                expenseTemplate: template,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const expenseTemplateLocal = response?.result;
            //#endregion data save

            //#region expenseTemplate dtUpdate
            $(`#${dtTemplatesId}`)?.DataTable()?.row?.add([
                //dateTimeFormatGlobalSet(expenseTemplateLocal?.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy).result,
                dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.date,
                    type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                expenseTemplateLocal?.description,
                //dateTimeFormatGlobalSet(expenseTemplateLocal?.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy).result,
                dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                buttonProcessGet({
                    id: expenseTemplateLocal?.id,
                    description: expenseTemplateLocal?.description,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result
            ])?.draw(true);

            setTemplate(
                expenseTemplateModelGet({
                    buildingId: expenseTemplateLocal?.buildingId,
                    userId: expenseTemplateLocal?.userId
                }));

            await dataTablesClearAsync({
                dtTemplates: false,
                dtConcepts: true,
                subMethod: currentMethod,
            });
            //#endregion expenseTemplate dtUpdate

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const expenseTemplateEditGetAsync = async ({ id = '', description = '', rowIndex = 0, subMethod = '', }) => {
        const currentMethod = 'expenseTemplateEditGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let dtRows = [];
            let expenseTemplateLocal = {};
            setReceitGeneratedMessage('');
            setTemplate(expenseTemplateModelGet({}));
            let expenseTemplateDetailsLocal = [expenseTemplateDetailModelGet({})];
            //#endregion variables

            //#region initialize
            response = await dateInControlSetAsync({
                date: new Date(),
                expenseTemplateDate: undefined,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return
            }

            response = await errosDefaultSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataTablesClearAsync({
                dtTemplates: false,
                dtConcepts: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: true, });

            //#region get expense template
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            expenseTemplateLocal = response?.result;
            setTemplate(expenseTemplateLocal);
            setProcessType(1);
            setDtExpenseTemplatesRowIndex(rowIndex);

            //#region old code
            // //#region check is edit / delete
            // localIsEdit = processEvaluateGet(localTemplate, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.edit?.en?.toLowerCase(), localSubMethodName).result;
            // localIsDelete = localIsEdit;
            // setIsEditDelete((localIsEdit && localIsDelete));
            // //#endregion check is edit / delete
            //#endregion old code
            //#endregion get expense template

            //#region dateInControles set
            response = await dateInControlSetAsync({
                date: null,
                expenseTemplateDate: expenseTemplateLocal?.date,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                return;
            }
            //#endregion dateInControls set

            //#region expenseTemplate check is edit
            setTemplateIsEditabled(true);
            if (!isUndNullEmp({ data: expenseTemplateLocal?.receiptLastGenerate, subMethod: currentMethod, })?.result && expenseTemplateLocal?.receiptLastGenerate?.length > 0) {
                setTemplateIsEditabled(false);
                let msgText = `${globalSettings?.messages?.lastReceiptGenerated?.[languageObj?.id]}: `;
                msgText += `<b>${expenseTemplateLocal?.receiptLastGenerate?.[0]?.number}</b> - `;
                msgText += `<b>${dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.receiptLastGenerate?.[0]?.created,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result}</b>`;
                setReceitGeneratedMessage(msgText);
            }
            //#endregion expenseTemplate check is edit

            //#region expenseTemplate details set
            expenseTemplateDetailsLocal = expenseTemplateLocal?.details || [];

            if (!isUndNullEmp({ data: expenseTemplateDetailsLocal, subMethod: currentMethod, })?.result && expenseTemplateDetailsLocal?.length > 0) {
                expenseTemplateDetailsLocal?.forEach((detail) => {
                    dtRows.push([
                        detail?.description,
                        //separatorsNumbersSet(detail?.quantity).result,
                        separatorsNumbersSet({
                            number: detail?.quantity,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        //separatorsNumbersSet(detail?.price).result,
                        separatorsNumbersSet({
                            number: detail?.price,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        //separatorsNumbersSet(numberSet((detail.quantity * detail.price), 'd').result).result,
                        separatorsNumbersSet({
                            number: numberSet({
                                number: (detail?.quantity * detail?.price),
                                type: 'd',
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result,
                        buttonProcessGet({
                            id: detail?.id,
                            description: detail?.description,
                            showDetails: false,
                            labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                            enabledDetails: false,
                            showEdit: true,
                            labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                            //#region old code
                            // templateIsEditabledTwo ?
                            //     processEvaluateGet(detail, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.edit?.en?.toLowerCase(), localSubMethodName).result :
                            //     templateIsEditabledTwo,
                            //#endregion old code
                            enabledEdit: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod
                            })?.result,
                            showDelete: true,
                            labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                            //#region old code
                            // templateIsEditabledTwo ?
                            //     processEvaluateGet(detail, globalSettings?.labels?.process?.en?.toLowerCase(), globalSettings?.labels?.edit?.en?.toLowerCase(), localSubMethodName).result :
                            //     templateIsEditabledTwo,
                            //#endregion old code
                            enabledDelete: processEvaluateGet({
                                object: detail,
                                property: globalSettings?.labels?.process?.en?.toLowerCase(),
                                process: globalSettings?.labels?.edit?.en?.toLowerCase(),
                                subMethod: currentMethod,
                            })?.result,
                            processButtons: [],
                            subMethod: currentMethod,
                        })?.result,
                    ]);
                });

                $(`#${dtConceptsId}`)?.DataTable()?.rows?.add(dtRows)?.draw(true);
            }
            //#endregion expenseTemplate details set

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const expenseTemplateEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'expenseTemplateEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 1, subMethod: subMethod, });

            //#region expenseTemplateBalance get
            response = await expenseTemplateBalanceGetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion expenseTemplateBalance get

            //#region expenseTemplate update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                expenseTemplate: template,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/${template.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const expenseTemplateLocal = response?.result;
            setTemplate(response?.result);
            //#endregion expenseTemplate update

            //#region dtExpenseTemplate update
            $(`#${dtTemplatesId}`)?.DataTable()?.row(dtExpenseTemplatesRowIndex)?.data?.([
                //dateTimeFormatGlobalSet(expenseTemplateLocal?.date, globalSettings?.react?.tempusDominus?.format?.date?.ymd).result,
                dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.date,
                    type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                expenseTemplateLocal?.description,
                //dateTimeFormatGlobalSet(expenseTemplateLocal?.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy).result,
                dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                buttonProcessGet({
                    id: expenseTemplateLocal?.id,
                    description: expenseTemplateLocal?.description,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);
            //#endregion dtExpenseTemplate update

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const expenseTemplateDeleteAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'expenseTemplateDeleteAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region data check
            if (isUndNullEmp({ data: template?.id, subMethod: currentMethod, })?.result) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion data check

            controlsStatusSet({ processType: 5, subMethod: currentMethod, });

            //#region receipt get
            response = await receiptGetAsync({
                id: template?.id,
                buildingId: template?.buildingId,
                showMessage: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion receipt get

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            //#region show message
            let msgTextObj = {
                one: `${globalSettings?.labels?.expenseTemplate?.[languageObj?.id]}: <b>${template?.description}</b><br/>`,
                two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}`,
                            showConfirmButton: false,
                        });

                        //#region expenseTemplate delete
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/${template?.id}`
                        };

                        result = await axios?.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion expenseTemplate delete

                        //#region dtExpenseTemplate update
                        $(`#${dtTemplatesId}`)?.DataTable()?.row(dtExpenseTemplatesRowIndex)?.remove()?.draw(true);

                        setTemplate(
                            expenseTemplateModelGet({
                                buildingId: template.buildingId,
                                userId: auth?.user?.uid,
                            })
                        );

                        setProcessType(0);
                        await dataTablesClearAsync({ dtTemplates: false, dtConcepts: true, subMethod: currentMethod, });
                        await dateInControlSetAsync({ date: new Date(), expenseTemplateDate: {}, processType: 1, subMethod: currentMethod, });
                        //#endregion dtExpenseTemplate update

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const expenseTemplateDuplicateGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'expenseTemplateDuplicateGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            if (processType === 1) {
                //#region show message
                response.msgText = `${globalSettings?.messages?.AnExactCopyWillBeGenerated?.[languageObj?.id]}<br/>`;
                response.msgText += `${globalSettings?.labels?.template?.[languageObj?.id]}: <b>${template?.description}</b><br/>`;
                response.msgText += `${globalSettings?.labels?.newTemplate?.[languageObj?.id]}: <b>${template?.description} - (${globalSettings?.labels?.copy?.[languageObj?.id]})</b><br/>`;
                response.msgText += `${globalSettings?.messages?.doYouWishContinue?.[languageObj?.id]}<br/>`;

                swalProperties = {
                    icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    title: globalSettings?.messages?.AreYouSureAboutThis?.[languageObj?.id],
                    html: response?.msgText,
                    timer: null,
                    confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                    showCancelButton: true,
                    cancelButtonColor: globalSettings?.colors?.successColorExp,
                    cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                };

                const { isConfirmed, } = await Swal.fire(swalProperties);
                //#endregion show message

                //#region create template (duplicate)
                if (isConfirmed) {
                    expenseTemplateDuplicatePostAsync({ subMethod: currentMethod, });
                }
                //#endregion create template (duplicate)
            } else {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: globalSettings?.messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const expenseTemplateDuplicatePostAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'expenseTemplateDuplicatePostAsync';
        let response = responseGet();
        try {
            //#region initialize
            template.created = new Date()?.toISOString();
            template.description = `${template?.description} - (${globalSettings?.labels?.copy?.[languageObj?.id]})`;
            await formDataSetAsync({
                property: 'description',
                value: `${template.description} - (${globalSettings?.labels?.copy?.[languageObj?.id]})`,
                subMethod: currentMethod,
            });

            setTemplate(template);

            response = await dateInControlSetAsync({
                date: new Date(),
                expenseTemplateDate: null,
                processType: 1,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            setProcessType(0);

            response = await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await dataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }

            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            controlsStatusSet({ processType: 3, subMethod: currentMethod, });

            //#region create explense template (duplicate)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                expenseTemplate: template,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            const expenseTemplateLocal = response?.result;
            setTemplate(expenseTemplateLocal);
            //#endregion create expense template (duplicate)

            //#region dtExpenseTemplates update
            $(`#${dtTemplatesId}`)?.DataTable()?.row?.add([
                //dateTimeFormatGlobalSet(expenseTemplateLocal?.date, globalSettings?.react?.tempusDominus?.format?.date?.ymd).result,
                dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.date,
                    type: globalSettings?.react?.tempusDominus?.format?.date?.ymdTwo,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                expenseTemplateLocal?.description,
                //dateTimeFormatGlobalSet(expenseTemplateLocal?.date, globalSettings?.react?.tempusDominus?.format?.date?.dmy).result,
                dateTimeFormatGlobalSet({
                    date: expenseTemplateLocal?.date,
                    type: languageObj?.format?.date?.f1,
                    format: 0,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result,
                buttonProcessGet({
                    id: expenseTemplateLocal?.id,
                    description: expenseTemplateLocal?.description,
                    showDetails: true,
                    labelDetails: globalSettings?.labels?.detail?.[languageObj?.id],
                    enabledDetails: true,
                    showEdit: false,
                    labelEdit: globalSettings?.labels?.edit?.[languageObj?.id],
                    enabledEdit: false,
                    showDelete: false,
                    labelDelete: globalSettings?.labels?.delete?.[languageObj?.id],
                    enabledDelete: false,
                    processButtons: [],
                    subMethod: currentMethod,
                })?.result,
            ])?.draw(true);

            setTemplate(
                expenseTemplateModelGet({
                    buildingId: expenseTemplateLocal?.buildingId,
                    userId: expenseTemplateLocal?.userId,
                })
            );

            setReceitGeneratedMessage('');
            await dataTablesClearAsync({ dtTemplates: false, dtConcepts: true, subMethod: currentMethod, });
            //#endregion update datatable

            controlsStatusSet({ processType: 0, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${controls?.inputs?.date?.id}`)?.val(),
                expenseTemplateDate: $(`#${templateDateId}`)?.datetimepicker('date')?._d,
            };
            let msgText = '';
            //#endregion variables

            //#region methods
            //#region old code
            // if (isUndNullEmp({ data: template?.buildingId, subMethod: currentMethod, })?.result) {
            //     template.buildingId = $(`#${buildingsId}`)?.val();
            // }

            // if (isUndNullEmp({ data: template?.buildingId, subMethod: currentMethod, })?.result) {
            //     template.buildingId = $(`#${buildingsId}`)?.val();
            // }
            //#endregion old code

            if (isUndNullEmp({ data: template?.description, subMethod: currentMethod, })?.result) {
                setDescriptionError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: template?.date, subMethod: currentMethod, })?.result) {
                setDateError(globalSettings?.messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            template.details = template?.details?.filter((obj) => !isUndNullEmp({ data: obj?.id, subMethod: currentMethod, })?.result);
            if (isUndNullEmp({ data: template?.details, subMethod: currentMethod, })?.result || template?.details?.length <= 0) {
                setDetailsError(globalSettings?.messages?.youMustAddLeastConcept?.[languageObj?.id]);
                response.isWarning = true;
            } else {
                //#region old code
                //template.details = orderBy(template.details, 'desc', 'asc');
                // template.details.some(function (detail) {// eslint-disable-line array-callback-return
                //     if (detail.quantity === 0.00) {
                //         msgText = `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${detail.description}</b><br/>`;
                //         msgText += `<b>${globalSettings?.labels?.quantity?.[languageObj?.id]}</b> ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>0.00</b><br/>`;
                //         //msgText += `${globalSettings?.labels?.registry}: <b>${key + 1}</b>`;
                //         sendMessage(1, msgText, 0, true, false, null, '');
                //         response.isWarning = true;
                //         return response;
                //     } else if (detail.price === 0.00) {
                //         msgText = `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${detail.description}</b><br/>`;
                //         msgText += `<b>${globalSettings?.labels?.price?.[languageObj?.id]}</b> ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>0.00</b><br/>`;
                //         //msgText += `${globalSettings?.labels?.registry}: <b>${key + 1}</b>`;
                //         sendMessage(1, msgText, 0, true, false, null, '');
                //         response.isWarning = true;
                //         return response;
                //     }
                // });
                //#endregion old code

                if (!response?.isWarning) {
                    const key = globalSettings?.collections?.properties?.description;
                    //template?.details?.sort((a, b,) => a?.description?.toLowerCase()?.localeCompare(b?.description?.toLowerCase()));
                    template?.details?.sort((a, b,) => a?.[key]?.toLowerCase() > b?.[key]?.toLowerCase() ? 1 : -1);
                    for (let detail of template?.details) {
                        if (detail?.quantity === 0.00) {
                            const numberStr = separatorsNumbersSet({
                                number: detail?.quantity,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result;
                            msgText = `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${detail?.description}</b><br/>`;
                            msgText += `<b>${globalSettings?.labels?.quantity?.[languageObj?.id]}</b> ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${numberStr}</b><br/>`;
                            response.isWarning = true;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: 1,
                                msgText: msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return response;
                        } else if (detail?.price === 0.00) {
                            const priceStr = separatorsNumbersSet({
                                number: detail?.price,
                                withDecimals: true,
                                consoleLogErrorShow: true,
                                subMethod: currentMethod,
                            })?.result;
                            msgText = `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${detail?.description}</b><br/>`;
                            msgText += `<b>${globalSettings?.labels?.price?.[languageObj?.id]}</b> ${globalSettings?.messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${priceStr}</b><br/>`;
                            response.isWarning = true;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: 1,
                                msgText: msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return response;
                        }
                    }

                }
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            setDateError('');
            setDetailsError('');
            setDescriptionError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataSetAsync = async ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            //#region old code
            //const date = $(`#${templateDateId}`)?.datetimepicker('date')?._d;
            //template.date = !isUndefined(date) ? date : template.date;
            //#endregion old code

            //#region variables
            const dateTimeObj = {
                date: $(`#${templateDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            template.date = !isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ? dateTimeObj?.date : template?.date;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const expenseTemplateBalanceGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'expenseTemplateBalanceGetAsync';
        let response = responseGet();
        try {
            //#region old code
            // if (!isUndNullEmp({data: template?.details, subMethod: currentMethod, })?.result && template?.details?.length > 0) {
            //     let expenseTemplateBalanceLocal = 0.00;
            //     template?.details?.forEach((detail) => {
            //         expenseTemplateBalanceLocal += (detail.quantity * detail.price);
            //     });
            //     //templateBalance = numberSet(templateBalance, 'd');
            //     expenseTemplateBalanceLocal = numberSet(expenseTemplateBalanceLocal, 'd').result;
            //     setTemplate({ ...template, balance: expenseTemplateBalanceLocal, });
            // }
            //#endregion old code

            //#region variables
            let expenseTemplateBalanceLocal = 0.00;
            //#endregion variables

            if (!isUndNullEmp({ data: template?.details, subMethod: currentMethod, })?.result && template?.details?.length > 0) {
                expenseTemplateBalanceLocal = template?.details?.reduce((acumulator, obj) => {
                    return acumulator + (obj?.quantity * obj?.price);
                }, 0);

                expenseTemplateBalanceLocal = numberSet({
                    number: expenseTemplateBalanceLocal,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                //setTemplate({ ...template, balance: expenseTemplateBalanceLocal, });
            } else {
                expenseTemplateBalanceLocal = numberSet({
                    number: expenseTemplateBalanceLocal,
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                //setTemplate({ ...template, balance: expenseTemplateBalanceLocal, });
            }
            setTemplate({ ...template, balance: expenseTemplateBalanceLocal, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    //#region old code
    // const localGetTemplateBalanceTwo = () => {
    //     let response = responseGet();
    //     try {
    //         if (!isUndefined(template) && !isUndefined(template.details) && !isNull(template.details) && template.details.length > 0) {
    //             let templateBalance = 0.00;
    //             map(template.details, (detail) => {
    //                 templateBalance += (detail.quantity * detail.price);
    //             });
    //             setTemplate({ ...template, balance: templateBalance, });
    //             template.balance = templateBalance;
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localGetTemplateBalanceTwo<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //     }
    //     return response;
    // }
    //#endregion old code
    //#endregion template (methods)

    //#region concepts (methods)
    const dataTableConceptsSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataTableConceptsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtConceptsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: globalSettings?.labels?.concept?.[languageObj?.id], width: '40%', },
                    { title: globalSettings?.labels?.quantity?.[languageObj?.id], className: 'text-right', width: '10%', },
                    { title: globalSettings?.labels?.price?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: globalSettings?.labels?.subTotal?.[languageObj?.id], className: 'text-right', width: '15%', },
                    { title: globalSettings?.labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'asc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtConceptsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptsByBuildingIdGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'conceptsByBuildingIdGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            //#region check if building is selected
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                responseIsWarning.msgText = globalSettings?.messages?.youMustSelectBuilding?.[languageObj?.id];
                $(`#${buildingsId}`)?.trigger('focus');
                return responseIsWarning;
            }
            //#endregion check if building is selected

            //#region receipts get
            if (processType !== 0) {
                response = await receiptGetAsync({
                    id: template?.id,
                    buildingId: template?.buildingId,
                    showMessage: true,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
            //#endregion receipts get

            //#region data get (concepts)
            //#region old code
            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     }
            // };
            // localData = {
            //     buildingId: localBuildingId,
            //     conditionals: [
            //         { field: globalSettings?.collections?.properties?.buildingId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${localBuildingId}` }
            //     ],
            //     ordersBy: [
            //         { field: globalSettings?.collections?.properties?.description, value: 'asc', }
            //     ],
            // };

            // //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseConcepts}/`, localData, headerObj);
            // result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseConcepts}/`, localData, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     return response;
            // }

            // if (isUndefined(response.result) || isNull(response.result) || response.result.length <= 0) {
            //     responseIsWarning.msgText = `${globalSettings?.messages?.youMustCreateLeastOneExpenseConcept?.[languageObj?.id]}<br/>`;
            //     responseIsWarning.msgText += `${globalSettings?.messages?.goTo?.[languageObj?.id]}: <i class='${globalSettings?.icons?.fileAltFar}'></i> `;
            //     responseIsWarning.msgText += `<a href='${globalSettings?.app?.backend?.urlExpenseConcepts}'>${globalSettings?.labels?.expenseConcepts?.[languageObj?.id]}</a>`;
            //     return responseIsWarning;
            // }
            //#endregion old code

            response = await validationExpenseConceptGetAsync({
                buildingId: buildingIdLocal,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
            //#endregion data get (concepts)
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }

    const conceptAddGetAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptAddGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let concepts = [{
                id: '',
                description: '',
            }];
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            //#endregion response is warning
            //#endregion variables

            controlsStatusSet({ processType: 4, subMethod: currentMethod, });

            //#region concepts get
            setConceptFinds([]);

            response = await conceptsByBuildingIdGetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            concepts = response?.result || [];
            //#endregion concepts get

            //#region show modal form
            response.result = [];
            concepts?.forEach((concept) => {
                let checkBoxHtml = `<div class='form-check'>`;
                checkBoxHtml += ` <input class='form-check-input' type='checkbox' value='' description='${concept?.description}' id='${concept?.id}'>`;
                checkBoxHtml += ` <label class='form-check-label' for='${concept?.id}'></label>`
                checkBoxHtml += `</div>`
                response.result.push([concept?.description, checkBoxHtml]);
            });

            setDetailsError('');
            setConceptFinds(response?.result);
            //#endregion show modal form

            setConceptAddShowModal(true);
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const conceptEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#region response is warning
            let responseIsWarning = responseGet();
            responseIsWarning.msgType = 1;
            responseIsWarning.isWarning = true;
            //#endregion response is warning
            //#endregion variables

            //#region Chgeck building
            if (isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                responseIsWarning.msgText = globalSettings?.messages?.youMustSelectBuilding?.[languageObj?.id];
                await sendMessageCloseCurrentWindowAsync({
                    msgType: responseIsWarning?.msgType,
                    msgText: !isUndNullEmp({ data: responseIsWarning?.msgHtml, subMethod: currentMethod, })?.result ? responseIsWarning?.msgHtml : responseIsWarning?.msgText,
                    closeWindow: false,
                    urlGoTo: responseIsWarning?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                $(`#${buildingsId}`)?.trigger('focus');
                return;
            }
            //#endregion check building

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: true, });

            //#region data get (receipt)
            if (!isUndNullEmp({ data: template?.id, subMethod: currentMethod, })?.result) {
                response = await receiptGetAsync({
                    id: template?.id,
                    buildingId: buildingIdLocal,
                    showMessage: true,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
            }
            //#endregion data get (receipt)

            //#region showModal
            setConceptEditShowModal(true);
            //#endregion showModal

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const conceptEditDeleteGetAsync = async ({ id = '', description = '', rowIndex = 0, processType = 0, subMethod = '', }) => {
        const currentMethod = 'conceptEditDeleteGetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#endregion variables

            //#region methods
            setConceptData({ id: id, description: description, rowIndex: rowIndex, processType: processType, });
            if (processType === -1) {
                $(`#${controls?.buttons?.conceptDelete?.id}`)?.trigger('click');
            } else if (processType === 1) {
                $(`#${controls?.buttons?.conceptEdit?.id}`)?.trigger('click');
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const conceptDeletePostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'conceptDeletePostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let expenseTemplateLocal = expenseTemplateModelGet({});
            //#endregion variables

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: true, });

            if (!isUndNullEmp({ data: template?.id, subMethod: currentMethod, })?.result) {
                //#region receipt check
                response = await receiptGetAsync({
                    id: template?.id,
                    buildingId: template?.buildingId,
                    showMessage: true,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion receipt check

                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                //#region show message
                let msgTextObj = {
                    one: `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${conceptData?.description}</b><br/>`,
                    two: `${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                };

                swalProperties = {
                    icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                    title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
                    html: `${msgTextObj?.one}${msgTextObj?.two}`,
                    timer: null,
                    backdrop: true,
                    confirmButtonColor: globalSettings?.colors?.warningColorExp,
                    confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
                    showCancelButton: true, //!Swal.isLoading(), //true,
                    cancelButtonColor: globalSettings?.colors?.successColorExp,
                    cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
                    showLoaderOnConfirm: true,
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                    preConfirm: async () => {
                        try {
                            Swal.getCancelButton().hidden = true;
                            Swal?.update({
                                icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                                title: `${globalSettings?.messages?.processing?.[languageObj?.id]}...`,
                                html: `${msgTextObj?.one}`,
                                showConfirmButton: false,
                            });

                            //#region delete expense concept
                            //#region remove concept from expenseConcept
                            expenseTemplateLocal = Object?.assign({}, template);
                            expenseTemplateLocal.details = expenseTemplateLocal?.details?.filter(({ id }) => id !== conceptData?.id);
                            //#endregion remove concept from expenseConcept

                            //#region update expense template
                            headerObj = {
                                headers: {
                                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                },
                            };

                            dataObj = {
                                expenseTemplate: expenseTemplateLocal,
                                languageId: languageObj?.id,
                                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/${expenseTemplateLocal?.id}`,
                            };

                            result = await axios?.post(
                                dataObj?.url,
                                dataObj,
                                headerObj,
                            );

                            response = result?.data;

                            if (!response?.isSuccess || response?.isWarning) {
                                await sendMessageCloseCurrentWindowAsync({
                                    msgType: response?.msgType,
                                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                    closeWindow: false,
                                    urlGoTo: response?.urlGoTo,
                                    auth: auth,
                                    isLogout: false,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod,
                                });
                                return;
                            }
                            //#endregion update expense template
                            //#endregion delete expense concept

                            //#region dtExpenseTemplate update
                            template.details = template.details.filter(({ id }) => id !== conceptData?.id);
                            response = await expenseTemplateBalanceGetAsync({ subMethod: currentMethod, });
                            if (!response?.isSuccess || response?.isWarning) {
                                return;
                            }

                            $(`#${dtConceptsId}`)?.DataTable()?.row(conceptData?.rowIndex)?.remove()?.draw(true);
                            //#endregion dtExpenseTemplate update

                            await sendMessageCloseCurrentWindowAsync({
                                msgType: 0,
                                msgText: `${globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                        } catch (ex) {
                            //#region Error
                            response.isSuccess = false;
                            response.msgType = -1;
                            response.msgText = `Method: ${currentMethod}<br/>`;
                            response.msgText += `Error: ${ex?.message}`;
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                            });
                            //#endregion Error
                        }
                    },
                    allowOutsideClick: () => !Swal.isLoading(),
                };

                await Swal.fire(swalProperties);
                //#endregion show message
            } else if (isUndNullEmp({ data: template?.id, subMethod: currentMethod, })?.result) {
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });

                template.details = template.details.filter(({ id }) => id !== conceptData?.id);
                response = await expenseTemplateBalanceGetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                    return;
                }
                $(`#${dtConceptsId}`)?.DataTable()?.row(conceptData?.rowIndex)?.remove()?.draw(true);
            }
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localconceptDeleteAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();

    //         sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         if (processType === -1) {
    //             sendMessage(1, globalSettings?.messages?.thisProcessAppliesOnlyToCreatedRecords?.[languageObj?.id], 0, true, false, null, '');
    //             return;
    //         }

    //         if (processType === 1) {
    //             response = await receiptGetAsync(template.id, template.buildingId, true);
    //             if (!response?.isSuccess || response?.isWarning) {
    //                 await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //                 return;
    //             }

    //             //#region show message

    //             swalProperties = {
    //                 icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //                 title: globalSettings?.messages?.areYouSureDeleteThis?.[languageObj?.id],
    //                 html: `${globalSettings?.labels?.concept?.[languageObj?.id]}: <b>${conceptDescription}</b><br/>${globalSettings?.messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
    //                 timer: null,
    //                 confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //                 confirmButtonText: globalSettings?.labels?.yes?.[languageObj?.id],
    //                 showCancelButton: true,
    //                 cancelButtonColor: globalSettings?.colors?.successColorExp,
    //                 cancelButtonText: globalSettings?.labels?.no?.[languageObj?.id],
    //                 didOpen: () => {
    //                     Swal.hideLoading();
    //                 },
    //             };

    //             //#region old code

    //             // Swal.fire(swalProperties).then((result) => {
    //             //     if (result.isConfirmed) {
    //             //         localConceptDeletePostAsync(template.id, conceptId, conceptDescription, dtConceptsRowIndex);
    //             //     }
    //             // });

    //             //#endregion old code

    //             const { isConfirmed, } = await Swal.fire(swalProperties);

    //             //#endregion show message

    //             //#region delete concept

    //             if (isConfirmed) {
    //                 localConceptDeletePostAsync(template.id, conceptId, conceptDescription, dtConceptsRowIndex);
    //             }

    //             //#endregion delete concept
    //         } else if (processType === 0) {
    //             $(`#${dtConceptsId}`)?.DataTable()?.row(dtConceptsRowIndex)?.remove()?.draw(true);
    //             template.details = template.details.filter(({ id }) => id !== conceptId);
    //             sendMessage(-2, '', 0, false, false, null, '');
    //         }
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localconceptDeleteAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localConceptDeletePostAsync = async (templateId = '', conceptId = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {
    //         sendMessage(2, globalSettings?.messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region calculate balance expense template

    //         $(`#${dtConceptsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
    //         template.details = template.details.filter(({ id }) => id !== conceptId);
    //         response = localGetTemplateBalanceTwo();
    //         if (!response?.isSuccess || response?.isWarning) {
    //             sendMessage(response.msgType, replaceMessages(0, response.msgText).result, 0, true, false, null, '');
    //             return;
    //         }

    //         //#endregion calculate balance expense template

    //         //#region update expense template

    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             }
    //         };
    //         //result = await axios?.post(`${globalSettings?.app?.backend?.urlDev}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/${template.id}`, template, headerObj);
    //         result = await axios?.post(`${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlExpenseTemplates}/${template.id}`, template, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return;
    //         }

    //         //#endregion update expense template

    //         sendMessage(0, globalSettings?.messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localConceptDeletePostAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code
    //#endregion concepts (methods)

    //#region apartment receipts
    const receiptGetAsync = async ({ id = '', buildingId = '', showMessage = false, subMethod = '', }) => {
        const currentMethod = 'receiptGetAsync';
        let response = responseGet();
        try {
            //#region initialize
            setTemplateIsEditabled(true);
            //templateIsEditabledTwo = true;
            //#endregion initialize

            //#region data get (receipts)
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                }
            };

            dataObj = {
                conditionals: [
                    //{ field: 'expenseTemplateId', operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${id}` },
                    { field: globalSettings?.collections?.properties?.expenseTemplateId, operator: globalSettings?.react?.firebase?.operators?.equalTo, value: `${id}` },
                ],
                ordersBy: [],
                buildingId: buildingId,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlReceipts}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod, })?.result && response?.result?.length > 0) {
                setTemplateIsEditabled(false);
                response.isWarning = showMessage;
                response.msgType = showMessage ? 1 : 0;
                response.msgText = `${globalSettings?.messages?.youCannotEditThisRecord?.[languageObj?.id]}<br/>`;
                response.msgText += `${globalSettings?.messages?.itRelatedOtherTables?.[languageObj?.id]}: <b>${globalSettings?.labels?.receipts?.[languageObj?.id]}<b/>`;
            }
            //#endregion receipts
        } catch (ex) {
            setTemplateIsEditabled(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion apartment receipts

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            setShowLoading({ buildings: true, expenseTemplates: true, expenseTemplate: true, });

            //#region dataTables set / set query code
            response = await dataTablesSetAsync({
                dtTemplates: true,
                dtConcepts: true,
                queryCodeSet_: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                return;
            }
            //#endregion dataTables set / set query code

            //#region set format dateTime picker
            response = await dateInControlSetAsync({
                date: new Date(),
                expenseTemplateDate: undefined,
                processType: 0,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                return
            }
            //#endregion set format dateTime picker

            //#region buildings get
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: globalSettings?.app?.backend?.urlExpenseTemplates,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion buildings get

            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
        } catch (ex) {
            setShowLoading({ buildings: false, expenseTemplates: false, expenseTemplate: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const queryCodeSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region set dt tamplate
            $(`#${dtTemplatesId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtTemplatesId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'details':
                            expenseTemplateEditGetAsync({ id: id, description: description, rowIndex: dtRowIndex, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion set dt tamplate

            //#region set dt concepts
            $(`#${dtConceptsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtConceptsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value || '';
                    method = e?.target?.attributes?.method?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (method) {
                        case 'edit':
                            conceptEditDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: 1, subMethod: currentMethod });
                            break;
                        case 'delete':
                            conceptEditDeleteGetAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion set dt concepts
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesClearAsync = async ({ dtTemplates = false, dtConcepts = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesClearAsync';
        let response = responseGet();
        try {
            if (dtTemplates) {
                $(`#${dtTemplatesId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
            if (dtConcepts) {
                $(`#${dtConceptsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dateInControlSetAsync = async ({ date = new Date(), expenseTemplateDate = {}, processType = 0, subMethod = '', }) => {
        const currentMethod = 'dateInControlSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: expenseTemplateDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: expenseTemplateDate,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            if (processType === 0) {
                $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                    icons: globalSettings?.react?.tempusDominus?.icons,
                    buttons: globalSettings?.react?.tempusDominus?.buttons,
                    tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                    locale: languageObj?.id,
                });

                $(`#${templateDateId}`)?.datetimepicker({
                    date: moment(dateTimeObj?.date, `${dateTimeObj?.formatTwo}`),
                    default: false,
                    format: `${dateTimeObj?.formatTwo}`,
                });
            } else if (processType === 1) {
                $(`#${templateDateId}`)?.datetimepicker('date', moment(dateTimeObj?.date, dateTimeObj?.formatTwo));
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesSetAsync = async ({ dtTemplates = false, dtConcepts = false, queryCodeSet_ = false, subMethod = '', }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            if (dtTemplates) {
                response = await dataTableTemplatesSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (dtConcepts) {
                response = await dataTableConceptsSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }

            if (queryCodeSet_) {
                response = await queryCodeSetAsync({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.new?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.new?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 3:
                    $(`#${controls?.icons?.duplicate?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.duplicate?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 4:
                    $(`#${controls?.icons?.addDetail?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.addDetail?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 5:
                    $(`#${controls?.icons?.delete?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.delete?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.inputs?.description?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.date?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.expenseTemplateTotal?.id}`)?.attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region url (register / passwords)
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion url (register / passwords)

            //#region url (rechaptcha)
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion url (rechaptcha)

            //#region urls
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion urls

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            //#region dataTable
            $(`#${controls?.dataTables?.expenseTemplate?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.expenseTemplate?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));
            //#endregion dataTable

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.new?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.duplicate?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.addDetail?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
                $(`#${controls?.buttons?.delete?.id}`)?.addClass(globalSettings?.react?.html?.button?.classes?.disabled);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='expenses' process='templates' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.templates?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.templates?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {/*buildings*/}
                        <BuildingHeader buildingsId={buildingsId}
                            building={building}
                            buildings={buildings}
                            btnSyncDisabled={btnTemplateSyncDisabled}
                            methodGetAsync={expenseTemplatesGetAsync}
                            processType={0}
                            headerSectionValues={{}}
                            showLoading={showLoading?.buildings}
                            languageObj={languageObj} />

                        {/* <div> */}
                        {/* {!showLoading ? */}
                        {/* <div> */}
                        {/* {showData ? */}
                        <div className='row'>
                            {/*templates*/}
                            <div className='col-md-6'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.expenseTemplates}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.templates?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseTemplatesLogo}></img> - {globalSettings?.labels?.templates?.[languageObj?.id]}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtTemplatesId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                            </div>
                                        </div>

                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                            </div>{/*col*/}

                            {/*template*/}
                            <div className='col-md-6'>
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={globalSettings?.react?.html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.expenseTemplate}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    {/*header*/}
                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={globalSettings?.labels?.template?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={globalSettings?.images?.expenseTemplateLogo}></img>
                                            - {globalSettings?.labels?.template?.[languageObj?.id]}
                                            {(processType === 0 ?
                                                (isEditDelete ? ` (${globalSettings?.labels?.create?.[languageObj?.id]})` : '')
                                                : processType === 1 ?
                                                    (isEditDelete ?
                                                        (isUndNullEmp({ data: receiptGeneratedMessage, subMethod: currentMethod, })?.result ?
                                                            ` (${globalSettings?.labels?.edit?.[languageObj?.id]})` :
                                                            ` (${globalSettings?.labels?.detail?.[languageObj?.id]})`) :
                                                        ` (${globalSettings?.labels?.detail?.[languageObj?.id]})`) : '')}
                                        </h6>
                                        <div className='card-tools'>
                                            <button type='button' className='btn btn-tool' data-card-widget='collapse'>
                                                <i className={globalSettings?.icons?.minus}></i>
                                            </button>
                                        </div>
                                    </div> {/*card header*/}

                                    {/*body*/}
                                    <div className='card-body'>
                                        <form onSubmit={(e) => processType === 0 ?
                                            expenseTemplateAddPostAsync({ e: e, subMethod: 'form - onSumit', }) :
                                            expenseTemplateEditPostAsync({ e: e, subMethod: 'form - onSubmit', })}>

                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.description?.id}
                                                                className={controls?.inputs?.description?.className}
                                                                //autoFocus
                                                                //disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                onChange={(e) => formDataSetAsync({
                                                                    property: 'description',
                                                                    value: e?.target?.value,
                                                                    subMethod: currentMethod,
                                                                })}
                                                                onFocus={() => setDescriptionError('')}
                                                                placeholder={globalSettings?.labels?.description?.[languageObj?.id]}
                                                                readOnly={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.description?.[languageObj?.id]}
                                                                value={template?.description || ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.spellCheck} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(descriptionError)}</div>
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group'>
                                                        {/* <DatePicker /> */}
                                                        <div className='input-group mb-3'>
                                                            <div className='input-group date'
                                                                disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                id={templateDateId}
                                                                data-target-input='nearest'>
                                                                <input id={controls?.inputs?.date?.id}
                                                                    className={controls?.inputs?.date?.className}
                                                                    data-target={`#${templateDateId}`}
                                                                    data-toggle='datetimepicker'
                                                                    disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                    onFocus={() => setDateError('')}
                                                                    placeholder={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                    //tabIndex={-1}
                                                                    //readOnly={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.date?.[languageObj?.id]}
                                                                    type='text' />
                                                                <div className='input-group-append' data-target={`#${templateDateId}`} data-toggle='datetimepicker'>
                                                                    <div className='input-group-text'><i className={globalSettings?.icons?.calendarAlt}></i></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-8'>
                                                    <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input id={controls?.inputs?.expenseTemplateTotal?.id}
                                                                className={controls?.inputs?.expenseTemplateTotal?.className}
                                                                readOnly
                                                                placeholder={globalSettings?.labels?.templateTotal}
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.templateTotal}
                                                                value={
                                                                    separatorsNumbersSet({
                                                                        number: template?.balance || 0.00,
                                                                        withDecimals: true,
                                                                        consoleLogErrorShow: true,
                                                                        subMethod: 'input - totalTemplate',
                                                                    })?.result
                                                                } />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className={globalSettings?.icons?.moneyBillWave} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='row'>
                                                <div className='col-md-5'>
                                                    <div className='form-group'>
                                                        {!isUndNullEmp({ data: receiptGeneratedMessage, subMethod: 'label - receiptGenerates - message', })?.result ?
                                                            <div className='form-text' style={styles.labelMsgPrimary}>
                                                                <i className={globalSettings?.icons?.warningTrinagle} style={styles.labelMsgWarning}></i> - {HtmlParser(receiptGeneratedMessage)}
                                                            </div>
                                                            :
                                                            <></>
                                                        }
                                                    </div>
                                                </div>

                                                <div className='col-md-7'>
                                                    <div className='form-group text-right'>
                                                        <button id={controls?.buttons?.save?.id}
                                                            className={controls?.buttons?.save?.className}
                                                            disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                            tooltip='tooltip'
                                                            title={processType === 0 ? globalSettings?.labels?.add?.[languageObj?.id] : globalSettings?.labels?.save?.[languageObj?.id]}
                                                            type='submit'>
                                                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.new?.id}
                                                            className={controls?.buttons?.new?.className}
                                                            disabled={processType === -1 || processType === 0 || !isEditDelete}
                                                            onClick={(e) => expenseTemplateAddGetAsync({ e: e, subMethod: currentMethod, })}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.new?.[languageObj?.id]}
                                                            type='button'>
                                                            <i id={controls?.icons?.new?.id} className={controls?.icons?.new?.className} /> <span id={controls?.spinners?.new?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.duplicate?.id}
                                                            className={controls?.buttons?.duplicate?.className}
                                                            disabled={processType === -1 || processType === 0 || !isEditDelete}
                                                            onClick={(e) => expenseTemplateDuplicateGetAsync({ e: e, subMethod: 'btn  duplicate', })}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.duplicate}
                                                            type='button'>
                                                            <i id={controls?.icons?.duplicate?.id} className={controls?.icons?.duplicate?.className} /> <span id={controls?.spinners?.duplicate?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.addDetail?.id}
                                                            className={controls?.buttons?.addDetail?.className}
                                                            disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                            onClick={(e) => conceptAddGetAsync({ e: e, subMethod: 'btn - addDetail', })}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.addDetail}
                                                            type='button'>
                                                            <i id={controls?.icons?.addDetail?.id} className={controls?.icons?.addDetail?.className} /> <span id={controls?.spinners?.addDetail?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                        <button id={controls?.buttons?.delete?.id}
                                                            className={controls?.buttons?.delete?.className}
                                                            disabled={processType !== 1 || !templateIsEditabled || !isEditDelete}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.delete?.[languageObj?.id]}
                                                            onClick={(e) => expenseTemplateDeleteAsync(e)}
                                                            type='button'>
                                                            <i id={controls?.icons?.delete?.id} className={controls?.icons?.delete?.className} /> <span id={controls?.spinners?.delete?.id} className='' aria-hidden='true'></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className='form-group text-right'>
                                                                <button className='btn btn-outline-primary mx-1'
                                                                    disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                    tooltip='tooltip'
                                                                    title={processType === 0 ? globalSettings?.labels?.add?.[languageObj?.id] : globalSettings?.labels?.save?.[languageObj?.id]}
                                                                    type='submit'>
                                                                    <i className={globalSettings?.icons?.save}></i>
                                                                </button>
                                                                <button className='btn btn-outline-success'
                                                                    disabled={processType === -1 || processType === 0 || !isEditDelete}
                                                                    onClick={(e) => expenseTemplateAddGetAsync(e)}
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.new?.[languageObj?.id]}
                                                                    type='button'>
                                                                    <i className={globalSettings?.icons?.fileAltFar}></i>
                                                                </button>
                                                                <button className='btn btn-outline-warning mx-1'
                                                                    disabled={processType === -1 || processType === 0 || !isEditDelete}
                                                                    onClick={(e) => expenseTemplateDuplicateGetAsync(e)}
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.duplicate}
                                                                    type='button'>
                                                                    <i className='far fa-copy'></i>
                                                                </button>
                                                                <button className='btn btn-outline-info'
                                                                    disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                                    onClick={(e) => conceptAddGetAsync(e)} tooltip='tooltip'
                                                                    title={globalSettings?.labels?.addDetail}
                                                                    type='button'>
                                                                    <i className={globalSettings?.icons?.listOl}></i>
                                                                </button>
                                                                <button className='btn btn-outline-danger  mx-1'
                                                                    disabled={processType !== 1 || !templateIsEditabled || !isEditDelete}
                                                                    tooltip='tooltip'
                                                                    title={globalSettings?.labels?.delete?.[languageObj?.id]}
                                                                    onClick={(e) => expenseTemplateDeleteAsync(e)}
                                                                    type='button'>
                                                                    <i className={globalSettings?.icons?.trash}></i>
                                                                </button>
                                                            </div> */}


                                            <div className='row' hidden={true}>
                                                <div className='col-md-8'>
                                                    {/* <div className='form-group'>
                                                        <div className='input-group mb-3'>
                                                            <input className='form-control bg-transparent text-black'
                                                                id={inputTemplateId}
                                                                placeholder={globalSettings?.labels?.key?.[languageObj?.id]}
                                                                readOnly
                                                                tooltip='tooltip'
                                                                title={globalSettings?.labels?.key?.[languageObj?.id]}
                                                                value={!isUndefined(template.id) && !isNull(template.id) && !isEmpty(template.id) ? template.id : ''} />
                                                            <div className='input-group-append'>
                                                                <div className='input-group-text'>
                                                                    <span className='fas fa-key' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                <div className='col-md-4'>
                                                    <div className='form-group text-right'>
                                                        <button id={controls?.buttons?.conceptEdit?.id}
                                                            className={controls?.buttons?.conceptEdit?.className}
                                                            disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.edit?.[languageObj?.id]}
                                                            onClick={(e) => conceptEditPostAsync({ e: e, subMethod: 'btn - conceptEdit', })}
                                                            type='button'>
                                                            <i className={globalSettings?.icons?.edit}></i>
                                                        </button>
                                                        <button id={controls?.buttons?.conceptDelete?.id}
                                                            className={controls?.buttons?.conceptDelete?.className}
                                                            //disabled={processType !== 1 || !templateIsEditabled || !isEditDelete}
                                                            disabled={processType === -1 || !templateIsEditabled || !isEditDelete}
                                                            tooltip='tooltip'
                                                            title={globalSettings?.labels?.delete?.[languageObj?.id]}
                                                            onClick={(e) => conceptDeletePostAsync({ e: e, subMethod: 'btn - conceptDelete', })}
                                                            type='button'>
                                                            <i className={globalSettings?.icons?.trash}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                        </form>

                                        <hr />
                                        {/* {!isEmpty(receiptGeneratedMessage) ?
                                            <div className='form-text' style={styles.labelMsgPrimary}>{HtmlParser(receiptGeneratedMessage)}</div>
                                            :
                                            <></>
                                        } */}
                                        <br />

                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtConceptsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(detailsError)}</div>
                                            </div>
                                        </div>

                                    </div> {/*card body*/}

                                    {/*footer*/}
                                    {/* <div className='card-footer'></div> */}

                                </div>{/*card*/}

                            </div>{/*col*/}
                        </div>
                        {/* : */}
                        {/* <div></div> */}
                        {/* } */}
                        {/* </div> */}
                        {/* : */}
                        {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                width={40}
                                height={40}
                                color={globalSettings?.colors?.infoColorExp}
                                msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                msgOrientation='text-center'
                                msgTextMuted={true} /> */}
                        {/* } */}
                        {/* </div> */}

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}
            </div>

            {conceptAddShowModal ?
                <ConceptFind $={$}
                    auth={auth}
                    concepts={conceptFinds}
                    template={template}
                    dtConceptsId={dtConceptsId}
                    dtConcepts={null}
                    showModal={conceptAddShowModal}
                    setShowModal={setConceptAddShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }

            {conceptEditShowModal ?
                <ConceptEdit $={$}
                    auth={auth}
                    conceptId={conceptData?.id}
                    template={template}
                    useRole={userRole}
                    showModal={conceptEditShowModal}
                    setShowModal={setConceptEditShowModal}
                    dtConceptsId={dtConceptsId}
                    dtConcepts={null}
                    rowIndex={conceptData?.rowIndex}
                    expenseTemplateBalanceGetAsync={expenseTemplateBalanceGetAsync}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}